import { Route, Routes } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import DefaultLayout from "../layouts/DefaultLayout";
import BookingPage from "../pages/BookingPage";
import PageNotFound from "../pages/PageNotFound";

const Routing = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicRoute />}>
        <Route element={<DefaultLayout />}>
          <Route path="/" element={<BookingPage />} />
        </Route>
      </Route>

      {/* Catch-All Route for 404 Not Found */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default Routing;
